import { takeLatest } from 'redux-saga/effects';
import { apiSaga } from '../../sagas';
import { billing as billingApi } from '../../api';

function* getInvoices({ type, payload }) {
  yield apiSaga(type, billingApi.getInvoices, [payload || {}]);
}
export default [
  takeLatest('{billing} getInvoices', getInvoices),
];



// WEBPACK FOOTER //
// ./src/app/stores/billing/billing-sagas.js